import React from 'react';

import styles from './Title.module.scss';

interface HeroProps {
  title: string;
  subTitle?: React.ReactNode;
}

const Hero: React.FC<HeroProps> = ({ title, subTitle }) => {
  return (
    <section aria-labelledby="hero-title" className={`${styles.Outer} ${subTitle ? styles.HasSubTitle : ''}`}>
      <div className="container">
        <h1 id="hero-title">{title}</h1>
        {subTitle ? <div className={styles.SubTitle}>{subTitle}</div> : null}
      </div>
    </section>
  );
};

export default Hero;
